import React, { memo } from 'react';

import type { SvgIconProps } from './icons/types';
import Call from './icons/Call';
import Check from './icons/Check';
import Close from './icons/Close';
import CloseBold from './icons/CloseBold';
import Email from './icons/Email';
import Gallery from './icons/Gallery';
import Phone from './icons/Phone';
import Telegram from './icons/Telegram';
import Whatsapp from './icons/Whatsapp';

const ICONS = {
  Call,
  Check,
  Close,
  CloseBold,
  Email,
  Gallery,
  Phone,
  Telegram,
  Whatsapp
};

export type IconName = keyof typeof ICONS;

interface IconProps extends SvgIconProps {
  name?: IconName;
}

const Icon = ({
  className,
  name,
  color = '#000',
  width,
  height
}: IconProps) => {
  if (!name) {
    return null;
  }

  const Element = ICONS[name];

  if (!Element) {
    return null;
  }

  return (
    <Element
      className={className}
      color={color}
      width={width}
      height={height}
    />
  );
};

export default memo(Icon);
